import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Container,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@material-ui/core";
import MainAnimation from "@components/MainAnimation";
import adminService from "@services/adminService";
import showToast from "../Toast";
import {
  VencimentoRcIds,
  VencimentosKCIds,
} from "../../utils/data/vencimentosRC";
import { ImgCotacao } from "@components/Feed/CotacaoInfo";
import TCButton from "../../components/TCButton";
import { rmPreSymbolLondres, rmPreSymbolNY } from "../../utils/showPreco";
import { FlashOn, PowerSettingsNew } from "@material-ui/icons";

function CotacaoPanel() {
  const [cotacao] = useSelector((states) => [states.cotacaoReducer]);

  const [checked, setChecked] = useState(!!cotacao.automatic);
  const [exportActive, setExportActive] = useState(!!cotacao.exportacoesActive);
  const [kc, setKc] = useState(cotacao.manualSymbolKC);
  const [rc, setRc] = useState(cotacao.manualSymbolRC);
  const [loading, setLoading] = useState(false);

  function putCotacao() {
    setLoading(true);
    return adminService
      .putCotacao({
        automatic: checked ? 1 : 0,
        exportacoesActive: exportActive ? 1 : 0,
        manualSymbolKC: kc,
        manualSymbolRC: rc,
      })
      .then(() => showToast.success("Cotacao Salva!"))
      .catch((e) => showToast.error(e.message))
      .finally(() => setLoading(false));
  }

  return (
    <MainAnimation>
      <Container maxWidth="xl" style={{ paddingTop: 20, display: "flex" }}>
        <Paper style={{ width: "100%", padding: 24, minHeight: 300 }}>
          <h1></h1>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: 12,
            }}
          >
            <Typography variant="subtitle1">
              {exportActive ? "Exportacoes Ativas" : "Exportacoes Inativas"}
            </Typography>
            <PowerSettingsNew
              style={{
                color: exportActive ? "#00cc00" : "#FFF",
                cursor: "pointer",
                transition: "all 0.3s ease-in-out",
                fontSize: 70,
              }}
              onClick={() => setExportActive(!exportActive)}
            />
            <Typography variant="subtitle1">
              {checked ? "Cotacoes Automatica" : "Cotacoes Manual"}
            </Typography>
            <FlashOn
              checked={!!checked}
              style={{
                color: checked ? "#ffcc00" : "#FFF",
                cursor: "pointer",
                transition: "all 0.3s ease-in-out",
                fontSize: 90,
              }}
              onClick={() => setChecked(!checked)}
            />

            {/* KC & RC Select */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginTop: 40,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <span>
                  <ImgCotacao /> NY
                </span>
                <Select
                  placeholder="Cotacao KC..."
                  variant="outlined"
                  value={kc}
                  onChange={(e) => setKc(e.target.value)}
                  style={{ minWidth: 120 }}
                >
                  {Object.keys(VencimentosKCIds).map((each) => (
                    <MenuItem key={each} value={rmPreSymbolNY(each)}>
                      {each}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <span>
                  <ImgCotacao isLondres /> Londres
                </span>
                <Select
                  placeholder="Cotacao RC..."
                  value={rc}
                  onChange={(e) => setRc(e.target.value)}
                  style={{ minWidth: 120 }}
                  variant="outlined"
                >
                  {Object.keys(VencimentoRcIds).map((each) => (
                    <MenuItem key={each} value={rmPreSymbolLondres(each)}>
                      {each}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>

            <TCButton loading={loading} onClick={putCotacao}>
              Salvar
            </TCButton>
          </div>
        </Paper>
      </Container>
    </MainAnimation>
  );
}

export default CotacaoPanel;
